/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Metaitemstitle2Inputs */

const id_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ms_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const da_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const de_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const en_us2_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const es_es2_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems`)
};

const es_mx2_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems`)
};

const fil_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Item`)
};

const fr_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const it_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articoli`)
};

const hu_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemek`)
};

const nl_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const no_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementer`)
};

const pl_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementy`)
};

const pt_br2_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens`)
};

const pt_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens`)
};

const ro_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemente`)
};

const fi_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohteet`)
};

const sv_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekt`)
};

const vi_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục`)
};

const tr_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğeler`)
};

const cs_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položky`)
};

const bg_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обекти`)
};

const ru_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объекты`)
};

const uk_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елементи`)
};

const ar_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العناصر`)
};

const hi_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम`)
};

const th_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการ`)
};

const ja_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム`)
};

const zh_cn2_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const zh_hant1_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const ko_sandboxes_metaitemstitle2 = /** @type {(inputs: Sandboxes_Metaitemstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템`)
};

/**
* | output |
* | --- |
* | "Items" |
*
* @param {Sandboxes_Metaitemstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_metaitemstitle2 = /** @type {((inputs?: Sandboxes_Metaitemstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Metaitemstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_metaitemstitle2(inputs)
	if (locale === "ms") return ms_sandboxes_metaitemstitle2(inputs)
	if (locale === "da") return da_sandboxes_metaitemstitle2(inputs)
	if (locale === "de") return de_sandboxes_metaitemstitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_metaitemstitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_metaitemstitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_metaitemstitle2(inputs)
	if (locale === "fil") return fil_sandboxes_metaitemstitle2(inputs)
	if (locale === "fr") return fr_sandboxes_metaitemstitle2(inputs)
	if (locale === "it") return it_sandboxes_metaitemstitle2(inputs)
	if (locale === "hu") return hu_sandboxes_metaitemstitle2(inputs)
	if (locale === "nl") return nl_sandboxes_metaitemstitle2(inputs)
	if (locale === "no") return no_sandboxes_metaitemstitle2(inputs)
	if (locale === "pl") return pl_sandboxes_metaitemstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_metaitemstitle2(inputs)
	if (locale === "pt") return pt_sandboxes_metaitemstitle2(inputs)
	if (locale === "ro") return ro_sandboxes_metaitemstitle2(inputs)
	if (locale === "fi") return fi_sandboxes_metaitemstitle2(inputs)
	if (locale === "sv") return sv_sandboxes_metaitemstitle2(inputs)
	if (locale === "vi") return vi_sandboxes_metaitemstitle2(inputs)
	if (locale === "tr") return tr_sandboxes_metaitemstitle2(inputs)
	if (locale === "cs") return cs_sandboxes_metaitemstitle2(inputs)
	if (locale === "bg") return bg_sandboxes_metaitemstitle2(inputs)
	if (locale === "ru") return ru_sandboxes_metaitemstitle2(inputs)
	if (locale === "uk") return uk_sandboxes_metaitemstitle2(inputs)
	if (locale === "ar") return ar_sandboxes_metaitemstitle2(inputs)
	if (locale === "hi") return hi_sandboxes_metaitemstitle2(inputs)
	if (locale === "th") return th_sandboxes_metaitemstitle2(inputs)
	if (locale === "ja") return ja_sandboxes_metaitemstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_metaitemstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_metaitemstitle2(inputs)
	return ko_sandboxes_metaitemstitle2(inputs)
});
export { sandboxes_metaitemstitle2 as "sandboxes.metaItemsTitle" }